<template>
  <div>
    <div class="d-flex align-center">
      <p class="font-weight-bold text-h5 ma-0">
        {{ headline }}
        <v-btn
          v-if="isEditIconShown && $auth.policies['import-invoices:update']"
          @click="$emit('onEdit', item.id)"
          icon
        >
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </p>
      <v-chip v-if="chip && chip.show" :color="chip.color" :text-color="chip.textColor" class="ml-2" small>
        {{ chip.text }}
      </v-chip>
    </div>
    <v-breadcrumbs class="pa-0 ma-0" v-if="!$vuetify.breakpoint.smAndDown" :items="links" icon=""
      ><template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template></v-breadcrumbs
    >
    <v-icon v-if="$vuetify.breakpoint.smAndDown" class="elevation-0 pa-0 ma-0" @click="comeBack()">
      mdi-arrow-left</v-icon
    >
  </div>
</template>

<script>
export default {
  props: {
    headline: String,
    caption: String,
    link: Array,
    isEditIconShown: Boolean,
    chip: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    items: [
      {
        text: 'Trang chủ',
        disabled: false,
        href: '/dashboard'
      }
    ],
    item: 123 // lấy id từ param
  }),
  computed: {
    links() {
      return [...this.items, ...this.link]
    }
  },
  methods: {
    comeBack() {
      history.back()
    }
  }
}
</script>
<style>
.v-breadcrumbs {
  padding: 0;
  margin: 0;
}

.v-breadcrumbs__divider {
  padding: 0 !important;
}
</style>
